import React, { useEffect } from "react";
import { Redirect, Route, Switch, useRouteMatch } from "react-router-dom";
import { Auth } from "shared/@auth/Auth";
import Page, { Content, Nav, NavGroup, NavItem } from "shared/Page";
import { IconHouseMeeting } from "@wwg/icons";
import { useCurrentRoute } from "shared/@hooks/useCurrentRoute";
import { HomePage } from "./HomePage/HomePage";
import { GroupsPage } from "./GroupsPage/GroupsPage";
import { GroupPage } from "./GroupsPage/GroupPage/GroupPage";
import { GlobalAdminsPage } from "./GroupsPage/GlobalAdminsPage/GlobalAdminsPage.jsx";
import { UsersPage } from "./UsersPage/UsersPage";
import { UsersDetailsPage } from "./UsersPage/UsersDetailsPage/UsersDetailsPage";
import { PostsPage } from "./PostsPage/PostsPage";
import { PluginsPage } from "./PluginsPage/PluginsPage";

import { ReactComponent as EventsIcon } from "./assets/Events.svg";
import { ReactComponent as GroupsIcon } from "./assets/Groups.svg";
import { ReactComponent as UsersIcon } from "./assets/User.svg";
import { ReactComponent as PluginsIcon } from "./assets/puzzle-piece-simple-solid.svg";

import { EventsPage } from "./EventsPage/EventsPage";
import { Dashboard } from "react-ikonate";

export function DreamStream() {
  const { path } = useRouteMatch();
  const { hasPermission } = Auth.useContainer();
  const { setCurrentRoute } = useCurrentRoute();

  useEffect(() => {
    setCurrentRoute("/dreamstream");
    return () => {
      setCurrentRoute("");
    };
  });

  return (
    <Page>
      <Nav>
        <NavGroup title="DreamStream">
          {hasPermission("dreamstream.*") && (
            <NavItem to={`${path}/home`} icon={<IconHouseMeeting />}>
              Home
            </NavItem>
          )}

          {hasPermission("dreamstream.*") && (
            <NavItem
              to={`${path}/groups`}
              icon={<GroupsIcon style={{ filter: "var(--icon-filter)" }} />}
            >
              Groups
            </NavItem>
          )}

          {/* {hasPermission("developer.*") && (
            <NavItem to={`${path}/users`} icon={<UsersIcon />}>
              Users
            </NavItem>
          )} */}

          {hasPermission("dreamstream.*") && (
            <NavItem
              to={`${path}/plugins`}
              icon={<PluginsIcon style={{ filter: "var(--icon-filter)" }} />}
            >
              Plugins
            </NavItem>
          )}

          {hasPermission("developer.*") && (
            <NavItem to={`${path}/events`} icon={<Dashboard />}>
              Events
            </NavItem>
          )}
        </NavGroup>
      </Nav>
      <Content>
        <Switch>
          {hasPermission("dreamstream.*") && (
            <Route path={`${path}/home`}>
              <HomePage />
            </Route>
          )}

          {hasPermission("dreamstream.*") && (
            <Route path={`${path}/groups`}>
              <GroupsPage />
            </Route>
          )}

          {hasPermission("developer.*") && (
            <Route path={`${path}/group`}>
              <GroupPage />
            </Route>
          )}
          {hasPermission("developer.*") && (
            <Route path={`${path}/global-admins`}>
              <GlobalAdminsPage />
            </Route>
          )}

          {hasPermission("developer.*") && (
            <Route path={`${path}/users`}>
              <UsersPage />
            </Route>
          )}

          {hasPermission("developer.*") && (
            <Route path={`${path}/user/details`}>
              <UsersDetailsPage />
            </Route>
          )}

          {hasPermission("developer.*") && (
            <Route path={`${path}/posts`}>
              <PostsPage />
            </Route>
          )}

          {hasPermission("dreamstream.*") && (
            <Route path={`${path}/plugins`}>
              <PluginsPage />
            </Route>
          )}

          {hasPermission("developer.*") && (
            <Route path={`${path}/events`}>
              <EventsPage />
            </Route>
          )}

          <Route path="*">
            <Redirect to={`${path}/home`} />
          </Route>
        </Switch>
      </Content>
    </Page>
  );
}
